import type { STWidgetProvideConfig } from '@delon/abc/st';

export const ST_WIDGETS: STWidgetProvideConfig[] = [];
